import * as React from "react"
import type { SVGProps } from "react"
const SvgHourglass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 20.43h8v-3q0-1.65-1.17-2.83-1.18-1.17-2.83-1.17c-1.65 0-2.04.39-2.82 1.17A4 4 0 0 0 8 17.43zm4-9q1.65 0 2.83-1.18A4 4 0 0 0 16 7.43v-3H8v3q0 1.65 1.18 2.83A4 4 0 0 0 12 11.43m-7 11a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.42.29-.71a1 1 0 0 1 .71-.3h1v-3q0-1.5.71-2.85a5.6 5.6 0 0 1 1.99-2.14 5.6 5.6 0 0 1-1.99-2.14A6 6 0 0 1 6 7.43v-3H5a1 1 0 0 1-.71-.29A1 1 0 0 1 4 3.43q0-.43.29-.71a1 1 0 0 1 .71-.3h14q.42 0 .71.3.3.29.29.7c-.01.42-.1.53-.29.72a1 1 0 0 1-.71.29h-1v3q0 1.53-.71 2.86a5.6 5.6 0 0 1-1.99 2.14 5.6 5.6 0 0 1 1.99 2.14q.7 1.33.71 2.86v3h1q.42 0 .71.29.3.29.29.7 0 .44-.29.72a1 1 0 0 1-.71.29z" />
  </svg>
)
export default SvgHourglass
